<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.13</b> - Ползунок золота в храме</p>
    <div class="ml-5 pb-4 text-yellow-400">
      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>
          Ползунок жертвоприношения золота в храме теперь ограничен максимальной эффективной суммой,
          вместо того чтобы позволять тратить больше необходимого
        </li>
      </ul>

      <div class="font-bold mt-2">Производительность</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлены утечки памяти из-за неправильной очистки визуальных объектов, особенно в Пещеры
        </li>
      </ul>
    </div>
  </div>
</template>
